import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { deleteVendor } from "redux/actions/vendor.action";
import ModalFooterDeleteClose from "../components/ModalFooterDeleteClose";
import ModalBodyDelete from "../components/ModalBodyDelete";

class VendorDeleteForm extends React.Component {
  render() {
    const {
      modal: { selectedData },
    } = this.props;
    return (
      <>
        <form>
          <ModalBodyDelete name={selectedData.name} />
          <ModalFooterDeleteClose
            click={() => {
              this.props.deleteVendor(selectedData.id);
            }}
          />
        </form>
      </>
    );
  }
}
export default connect(
  ({ modal, user }) => ({ modal, user }),
  (dispatch) => bindActionCreators({ deleteVendor }, dispatch),
)(VendorDeleteForm);
